module.exports = __webpack_public_path__ + "static/media/logowhite.be466799.png";